import React, { useState } from "react";
import Logo from "../../assets/images/logo.png";
import "./Navbar.css";
import Mobilebar from "./Mobilebar";
import { Link } from "react-router-dom";
import ServicesModal from "./Components/ServicesModal/ServicesModal";
const Navbar = () => {
  const [modal, setModal] = useState(0);
  const showModal = (mdl) => {
    setModal(mdl);
  };
  const hideModal = () => {
    setModal(0);
  };
  return (
    <>
      <div className="navbar__wrap">
        <div className="navbar__left">
          <Link to="/">
            <img src={Logo} className="navbar__logo" />
          </Link>
        </div>
        <div className="navbar__right">
          <div className="navbar__right_options">
            <Link className="navbar__right_option" to="/about">
              About Us
            </Link>
            <Link className="navbar__right_option" to="/why-serene">
              Why Serene
            </Link>
            <Link
              className="navbar__right_option"
              onMouseEnter={() => setModal("services")}
              onMouseLeave={() => setModal()}
            >
              Services
              {modal === "services" && (
                <ServicesModal
                  style={{ top: "15px" }}
                  onClose={() => {
                    setModal(0);
                  }}
                  closeOnLeave={true}
                />
              )}
            </Link>
            <Link className="navbar__right_option" to="/pricing">
              Pricing
            </Link>
            <Link className="navbar__right_option" to="/contact-us">
              Contact
            </Link>
            <Link className="navbar__right_option" to="/login">
              Login/Register
            </Link>
          </div>
          <button className="navbar__right_btn">Free Consultant</button>
        </div>
      </div>
      <Mobilebar />
    </>
  );
};

export default Navbar;
